import React from 'react';
import Level from '../components/modals/wModal/Level';
import Rewards from '../components/modals/wModal/rewards/Rewards';
import Buttons from '../components/modals/wModal/Buttons';
import Title from '../components/modals/wModal/Title';
import Logo from '../components/modals/wModal/Logo';
import Description from '../components/modals/wModal/Description';
import Selection from '../components/modals/wModal/selection/Selection';
import Date from '../components/modals/wModal/Date';
import Preview from '../components/modals/wModal/Preview';
import InfoButton from '../components/modals/wModal/InfoButton';
import Score from '../components/modals/wModal/score/Score';
import NoteValue from '../components/modals/wModal/noteValue';

export const types = {
  level: {
    content: [
      {
        getContext({ lvl, description }) {
          return { lvl, description };
        },
        Component: (props) => props.lvl && <Level {...props} />,
      },
      {
        getContext({ title }) {
          return { title };
        },
        Component: (props) => <Title {...props} />,
      },
      {
        getContext({ rewards, lvl, extraIcons }) {
          return rewards ? { rewards, lvl, ...(extraIcons ? { extraIcons } : {}) } : null;
        },
        Component: (props) => <Rewards {...props} />,
      },
      {
        getContext({ buttons, prize, callbacks, close }) {
          return buttons ? { buttons, prize, callbacks, close } : null;
        },
        Component: (props) => <Buttons {...props} isGray={props?.prize?.promocode} />,
      },
    ],
  },
  gameWin: {
    content: [
      {
        getContext({ title }) {
          return title ? { title } : null;
        },
        Component: (props) => <Title {...props} />,
      },
      {
        getContext({ rewards, extraIcons }) {
          return rewards ? { rewards, ...(extraIcons ? { extraIcons } : {}) } : null;
        },
        Component: (props) => <Rewards {...props} />,
      },
      {
        getContext({ description }) {
          return description ? { description } : null;
        },
        Component: (props) => <Description {...props} />,
      },
      {
        getContext({ buttons, selfClose, callbacks }) {
          return buttons ? { buttons, selfClose, callbacks } : null;
        },
        Component: (props) => <Buttons {...props} />,
      },
    ],
  },
  taskDescription: {
    content: [
      {
        getContext({ logo }) {
          return logo ? { logo } : null;
        },
        Component: (props) => <Logo {...props} />,
      },
      {
        getContext({ title, ...props }) {
          return title || props?.titleData
            ? { title, ...(props?.titleData ? { titleData: props.titleData } : {}) }
            : null;
        },
        Component: (props) => <Title {...props} />,
      },
      {
        getContext({ rewards, extraIcons }) {
          return rewards ? { rewards, ...(extraIcons ? { extraIcons } : {}) } : null;
        },
        Component: (props) => <Rewards {...props} />,
      },
      {
        getContext({ score }) {
          return score ? { score } : null;
        },
        Component: (props) => <Score {...props} />,
      },
      {
        getContext({ description }) {
          return description ? { description } : null;
        },
        Component: (props) => <Description {...props} />,
      },
      {
        getContext(data) {
          const { buttons, callbacks } = data;
          return buttons ? { buttons, callbacks, ...(data.title ? { title: data.title } : {}) } : null;
        },
        Component: (props) => <Buttons {...props} />,
      },
      {
        getContext(data) {
          return data.selection ? { selection: data.selection, ...(data.title ? { title: data.title } : {}) } : null;
        },
        Component: (props) => <Selection {...props} />,
      },
    ],
  },
  drawResult: {
    content: [
      {
        getContext({ infoButton }) {
          return infoButton ? { infoButton, isModal: true } : null;
        },
        Component: (props) => <InfoButton {...props} />,
      },
      {
        getContext({ preview }) {
          return preview ? { preview } : null;
        },
        Component: (props) => <Preview {...props.preview} />,
      },
      {
        getContext({ title }) {
          return title ? { title } : null;
        },
        Component: (props) => <Title {...props} />,
      },
      {
        getContext({ description }) {
          return description ? { description } : null;
        },
        Component: (props) => <Description {...props} />,
      },
      {
        getContext({ date }) {
          return date ? { date } : null;
        },
        Component: (props) => <Date {...props} />,
      },
      {
        getContext({ buttons, callbacks }) {
          return buttons ? { buttons, callbacks } : null;
        },
        Component: (props) => <Buttons {...props} />,
      },
    ],
  },
  message: {
    content: [
      {
        getContext({ logo }) {
          return logo ? { logo } : null;
        },
        Component: (props) => <Logo {...props} />,
      },
      {
        getContext({ title, titleIcon }) {
          return title ? { title, titleIcon } : null;
        },
        Component: (props) => <Title {...props} />,
      },
      {
        getContext({ description }) {
          return description ? { description } : null;
        },
        Component: (props) => <Description {...props} />,
      },
      {
        getContext({ buttons, selfClose, changeState, callbacks, nextModalData }) {
          return buttons ? { buttons, nextModalData, changeState, selfClose, callbacks } : null;
        },
        Component: (props) => <Buttons {...props} />,
      },
    ],
  },
  converterResult: {
    content: [
      {
        getContext({ rewards, lvl, extraIcons }) {
          return rewards ? { rewards, lvl, ...(extraIcons ? { extraIcons } : {}) } : null;
        },
        Component: (props) => <Rewards {...props} isGradeLvl={props?.lvl === 6 || props?.lvl === 11} />,
      },
      {
        getContext({ title }) {
          return title ? { title } : null;
        },
        Component: (props) => <Title {...props} />,
      },
      {
        getContext({ description }) {
          return description ? { description } : null;
        },
        Component: (props) => <Description {...props} />,
      },
      {
        getContext({ noteValue }) {
          return noteValue ? { noteValue } : null;
        },
        Component: (props) => <NoteValue {...props} />,
      },
      {
        getContext({ buttons, prize, callbacks, close }) {
          return buttons ? { buttons, prize, callbacks, close } : null;
        },
        Component: (props) => <Buttons {...props} isGray={props?.prize?.promocode} />,
      },
    ],
  },
};
